
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const usePasswordReset = (email: string, setLoading: (loading: boolean) => void) => {
  const { toast } = useToast();

  const handleResetPassword = async () => {
    if (!email) {
      toast({
        title: "Email requis",
        description: "Veuillez entrer votre adresse email pour réinitialiser votre mot de passe.",
        variant: "destructive",
      });
      return;
    }

    setLoading(true);
    try {
      // Use the current origin (domain) the app is running on
      const origin = window.location.origin;
      const redirectUrl = `${origin}/auth/callback`;
      
      console.log("Using reset password redirect URL:", redirectUrl);

      const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: redirectUrl,
      });

      if (error) throw error;

      console.log("Reset password email sent:", data);
      toast({
        title: "Email envoyé",
        description: "Un lien de réinitialisation de mot de passe vous a été envoyé par email. Vérifiez aussi vos spams.",
      });
    } catch (error: any) {
      console.error("Error sending reset password email:", error);
      toast({
        title: "Erreur",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return { handleResetPassword };
};
